import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/banner2/3-2.png'
import _imports_1 from '../../assets/img/step/step-top.svg'
import _imports_2 from '../../assets/img/step/step-ico.svg'
import _imports_3 from '../../assets/img/tradingSystem/new-tag.png'
import _imports_4 from '../../assets/img/bidEvaluationTools/time.png'
import _imports_5 from '../../assets/img/tradingSystem/npapp.png'
import _imports_6 from '../../assets/img/delstep.svg'
import _imports_7 from '../../assets/img/addstep.svg'
import _imports_8 from '../../assets/img/tradingSystem/noimg.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-eb0ef78c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"banner\" data-v-eb0ef78c><div class=\"banner-center\" data-v-eb0ef78c><div class=\"textbox\" data-v-eb0ef78c><div class=\"banner-text1\" data-v-eb0ef78c>互联电子评标工具</div><div class=\"banner-text2\" data-v-eb0ef78c>助力建设全国统一大市场，优化市场营商环境</div></div><div data-v-eb0ef78c><img src=\"" + _imports_0 + "\" alt=\"\" class=\"banner-img\" data-v-eb0ef78c></div></div></div>", 1)
const _hoisted_2 = { class: "box1" }
const _hoisted_3 = { class: "stepbox" }
const _hoisted_4 = { class: "stepitembg" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overtop" }, null, -1))
const _hoisted_6 = { class: "stepitem" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"step-top\" data-v-eb0ef78c><img src=\"" + _imports_1 + "\" alt=\"\" style=\"width:133px;height:70px;\" data-v-eb0ef78c></div><div class=\"stepindex\" data-v-eb0ef78c>1</div><div class=\"stepico\" data-v-eb0ef78c><img src=\"" + _imports_2 + "\" alt=\"\" style=\"width:32px;height:35px;\" data-v-eb0ef78c></div><div class=\"stepTitle\" data-v-eb0ef78c> 阅读接入指南 </div><div class=\"stepText\" data-v-eb0ef78c> 预览、下载《远程异地评标和评标专家库共享技术标准_电子评标工具接入指南》 </div>", 5)
const _hoisted_12 = { style: {"display":"flex","margin-top":"54px","justify-content":"space-evenly","padding":"0 10px"} }
const _hoisted_13 = { class: "stepitembg" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overtop" }, null, -1))
const _hoisted_15 = { class: "stepitem" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"step-top\" data-v-eb0ef78c><img src=\"" + _imports_1 + "\" alt=\"\" style=\"width:133px;height:70px;\" data-v-eb0ef78c></div><div class=\"stepindex\" data-v-eb0ef78c>2</div><div class=\"stepico\" data-v-eb0ef78c><img src=\"" + _imports_2 + "\" alt=\"\" style=\"width:32px;height:35px;\" data-v-eb0ef78c></div><div class=\"stepTitle\" data-v-eb0ef78c> 远程异地评标 <br data-v-eb0ef78c>目录服务组件集成对接 </div><div class=\"stepText\" data-v-eb0ef78c> 运营机构联系中国招标投标公共服务平台运维实施人员集成对接远程异地评标共享目录服务组件 </div>", 5)
const _hoisted_21 = { style: {"display":"flex","margin-top":"14px","justify-content":"space-evenly","padding":"0 10px"} }
const _hoisted_22 = { class: "stepitembg" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overtop" }, null, -1))
const _hoisted_24 = { class: "stepitem" }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"step-top\" data-v-eb0ef78c><img src=\"" + _imports_1 + "\" alt=\"\" style=\"width:133px;height:70px;\" data-v-eb0ef78c></div><div class=\"stepindex\" data-v-eb0ef78c>3</div><div class=\"stepico\" data-v-eb0ef78c><img src=\"" + _imports_2 + "\" alt=\"\" style=\"width:32px;height:35px;\" data-v-eb0ef78c></div><div class=\"stepTitle\" data-v-eb0ef78c> 与跨省远程异地目录服务<br data-v-eb0ef78c>组件共同联调测试 </div><div class=\"stepText\" data-v-eb0ef78c> 与跨省远程异地目录服务组件共同联调测试相关接口 </div>", 5)
const _hoisted_30 = { style: {"display":"flex","margin-top":"34px","justify-content":"space-evenly","padding":"0 10px"} }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"stepitembg\" data-v-eb0ef78c><div class=\"overtop\" data-v-eb0ef78c></div><div class=\"stepitem\" data-v-eb0ef78c><div class=\"step-top\" data-v-eb0ef78c><img src=\"" + _imports_1 + "\" alt=\"\" style=\"width:133px;height:70px;\" data-v-eb0ef78c></div><div class=\"stepindex\" data-v-eb0ef78c>4</div><div class=\"stepico\" data-v-eb0ef78c><img src=\"" + _imports_2 + "\" alt=\"\" style=\"width:32px;height:35px;\" data-v-eb0ef78c></div><div class=\"stepTitle\" data-v-eb0ef78c> 公开测试承诺 </div><div class=\"stepText\" data-v-eb0ef78c> 与跨省远程异地目录服务组件共同联调测试通过后，通过远程异地评标和评标专家库共享目录服务组件自助管理终端，上传并公开测试承诺书和自主测试报告，自助加入电子评标工具互联目录 </div></div></div>", 1)
const _hoisted_32 = { class: "box2" }
const _hoisted_33 = { class: "box2-top" }
const _hoisted_34 = { class: "search" }
const _hoisted_35 = {
  key: 0,
  class: "content"
}
const _hoisted_36 = {
  class: "platformtype-title",
  style: {"border-bottom":"1px solid #EBEBED"}
}
const _hoisted_37 = { class: "contentbox" }
const _hoisted_38 = ["onMouseover", "onMouseout", "onClick"]
const _hoisted_39 = { class: "center" }
const _hoisted_40 = ["src"]
const _hoisted_41 = {
  key: 0,
  src: _imports_3,
  alt: "",
  class: "new-tag"
}
const _hoisted_42 = { class: "center2" }
const _hoisted_43 = { class: "top2" }
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "infobox" }
const _hoisted_46 = { class: "text-box1" }
const _hoisted_47 = { class: "text-box" }
const _hoisted_48 = { style: {"display":"flex","align-items":"center","margin-top":"10px"} }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  style: {"width":"14px","height":"14px"}
}, null, -1))
const _hoisted_50 = {
  class: "info-text3",
  style: {"margin-left":"3px"}
}
const _hoisted_51 = { class: "center" }
const _hoisted_52 = { class: "noplatform" }
const _hoisted_53 = {
  class: "platformtype-title",
  style: {"margin-top":"16px"}
}
const _hoisted_54 = { class: "municipality-title" }
const _hoisted_55 = { class: "municipality-name" }
const _hoisted_56 = { class: "municipality-total" }
const _hoisted_57 = ["onMouseenter", "onMouseleave"]
const _hoisted_58 = { style: {"position":"relative","width":"1153px","margin":"0 auto"} }
const _hoisted_59 = { class: "contentbox2" }
const _hoisted_60 = { class: "center" }
const _hoisted_61 = ["src"]
const _hoisted_62 = {
  key: 0,
  src: _imports_3,
  alt: "",
  class: "new-tag"
}
const _hoisted_63 = {
  key: 1,
  class: "cityName"
}
const _hoisted_64 = { class: "center2" }
const _hoisted_65 = { class: "top2" }
const _hoisted_66 = ["src"]
const _hoisted_67 = { class: "infobox" }
const _hoisted_68 = { class: "text-box1" }
const _hoisted_69 = { class: "text-box" }
const _hoisted_70 = { style: {"display":"flex","align-items":"center","margin-top":"10px"} }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  style: {"width":"14px","height":"14px"}
}, null, -1))
const _hoisted_72 = {
  class: "info-text3",
  style: {"margin-left":"3px"}
}
const _hoisted_73 = ["onMouseover", "onMouseout", "onClick"]
const _hoisted_74 = { class: "center" }
const _hoisted_75 = ["src"]
const _hoisted_76 = {
  key: 0,
  src: _imports_3,
  alt: "",
  class: "new-tag"
}
const _hoisted_77 = {
  key: 1,
  class: "cityName"
}
const _hoisted_78 = { class: "center2" }
const _hoisted_79 = { class: "top2" }
const _hoisted_80 = ["src"]
const _hoisted_81 = { class: "infobox" }
const _hoisted_82 = { class: "text-box1" }
const _hoisted_83 = { class: "text-box" }
const _hoisted_84 = { style: {"display":"flex","align-items":"center","margin-top":"10px"} }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  style: {"width":"14px","height":"14px"}
}, null, -1))
const _hoisted_86 = {
  class: "info-text3",
  style: {"margin-left":"3px"}
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: "",
    class: "appimg3",
    style: {"border":"none"}
  })
], -1))
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = ["onClick"]
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "",
  style: {"width":"16px","height":"16px"}
}, null, -1))
const _hoisted_91 = [
  _hoisted_90
]
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "",
  style: {"width":"16px","height":"16px"}
}, null, -1))
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = {
  key: 1,
  class: "content"
}
const _hoisted_95 = {
  key: 0,
  class: "searchBox"
}
const _hoisted_96 = ["onMouseover", "onMouseout", "onClick"]
const _hoisted_97 = { class: "center" }
const _hoisted_98 = ["src"]
const _hoisted_99 = { class: "center2" }
const _hoisted_100 = { class: "top2" }
const _hoisted_101 = ["src"]
const _hoisted_102 = { class: "infobox" }
const _hoisted_103 = { class: "text-box1" }
const _hoisted_104 = { class: "text-box" }
const _hoisted_105 = { style: {"display":"flex","align-items":"center","margin-top":"10px"} }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  style: {"width":"14px","height":"14px"}
}, null, -1))
const _hoisted_107 = {
  class: "info-text3",
  style: {"margin-left":"3px"}
}
const _hoisted_108 = {
  key: 2,
  class: "nodata"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: "",
  style: {"width":"80px","height":"80px"}
}, null, -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text1" }, "暂无内容", -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text2" }, "没有搜到想要的内容？您可 联系我们 进行咨询", -1))
const _hoisted_112 = [
  _hoisted_109,
  _hoisted_110,
  _hoisted_111
]
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"66px","width":"100px"} }, null, -1))

import { reactive, toRefs, ref, onMounted, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import { useRouter } from "vue-router";
import mytitle from '../../components/title.vue'

import { getappList, endpointDownload, documentPreview, getSDK, DownloadTestScripts, downloadWithFilePath, getintroduction, autonomyTest } from '../../utils/axios/index.js'
import { ElMessage } from 'element-plus'
import { isMobile } from '../../utils/validate'
import infoDailog from '../infoDailog.vue'


import contactUs from '../../components/contactUs.vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'bidEvaluationTools',
  setup(__props) {

const route = useRoute()
const router = useRouter();

let showContactUs1 = ref(false)


const totest = () => {
    autonomyTest({}).then(res => {
        window.open(res.data.autonomyTestAddr, '_blank');
    })
}

//指南预览
const Previewzn = (type: any) => {
    window._czc.push(['_trackEvent', '电子评标工具', '预览', '电子评标工具接入指南预览'])

    window.open('S02远程异地评标和评标专家库共享技术标准_电子评标工具接入指南_20250605_1600.pdf', '_blank');

    // ElMessage.warning('功能开发中，敬请期待！')
}


// 指南下载

const downzn = (type: any, name: any) => {
    // window._czc.push(['_trackEvent', '互认APP', '下载', 'APP接入指南下载'])
    // let name2 = ''
    // documentPreview({ documentType: type }).then(res => {
    //     name2 = res.data.documentName
    //     endpointDownload({ documentType: type }).then(res => {
    //         var blob = new Blob([res])
    //         let fname = name2 + '.pdf'; //下载文件的名字
    //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //             window.navigator.msSaveOrOpenBlob(blob, fname);
    //         } else {
    //             let objectUrl = URL.createObjectURL(blob);
    //             let link = document.createElement("a");
    //             link.href = objectUrl;
    //             link.setAttribute("download", fname);
    //             document.body.appendChild(link);
    //             link.click();
    //         }


    //     }).catch(res => {

    //     })

    // }).catch(res => {
    //     ElMessage.warning('功能开发中，敬请期待！')
    // })

    // ElMessage.warning('功能开发中，敬请期待！')
    window._czc.push(['_trackEvent', '电子评标工具', '下载', '电子评标工具接入指南下载'])
    const a = document.createElement('a')
    a.href = 'S02远程异地评标和评标专家库共享技术标准_电子评标工具接入指南_20250605_1600.pdf'
    a.download = 'S02远程异地评标和评标专家库共享技术标准_电子评标工具接入指南_20250605_1600.pdf'
    a.click()



}

// 搜索参数

let Listparms = ref({
    current: '1',
    size: 500,
    appName: '',
    status: '1',
    ascs: 'publish_time',

})

// 查看更多
const showmorelist = () => {
    Listparms.value.size = Listparms.value.size + 8
    MgetappList()
}
// 搜索
const searchApp = () => {
    Listparms.value.size = 500
    MgetappList()
}
//总数
let total = ref(0)
// 获取app列表

const MgetappList = () => {
    getappList(Listparms.value).then(res => {
        applist.value = res.data.records
        total.value = res.data.total
        applist.value.map(item => {
            item.ishover = false

        })


    }).catch(err => {

    })
}
//跳转链接
const showpdf = (url, type) => {
    if (type == 1) {
        window.open(url, '_blank');
    } else {
        window.open(url, '_self');
    }

}

//填写信息弹框
let showRegister = ref(false)
let registrationType = ref(1)
const openDialog = () => {
    // canDownload()
    window._czc.push(['_trackEvent', '互认APP', '下载SDK', '下载APP-SDK'])

    showRegister.value = true

    // getSDK({}).then(res => {
    //     if (res.data.sdkUrl) {
    //         showRegister.value = true
    //     } else {
    //         ElMessage.warning('功能开发中，敬请期待！')
    //     }
    // })
}

// 关闭弹框
const confirm = () => {
    showRegister.value = false

}
//下载
const canDownload = () => {
    window.open('https://www.yunpan.com/surl_y9f64CK8eDR', '_blank')
    // getSDK({}).then(res1 => {
    //     showpdf(res1.data.sdkUrl)
    //     // const url = new URL(res1.data.sdkUrl)
    //     // let path = String(url.pathname)
    //     // downloadWithFilePath({ contentDisposition: 'attachment', filePath: path }).then(res => {

    //     //     var blob = new Blob([res])
    //     //     let fname = res1.data.sdkName + '.zip'; //下载文件的名字
    //     //     if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //     //         window.navigator.msSaveOrOpenBlob(blob, fname);
    //     //     } else {
    //     //         let objectUrl = URL.createObjectURL(blob);
    //     //         let link = document.createElement("a");
    //     //         link.href = objectUrl;
    //     //         link.setAttribute("download", fname);
    //     //         document.body.appendChild(link);
    //     //         link.click();
    //     //     }

    //     // })

    // }).catch(res => {

    // })







}

onMounted(async () => {
    await nextTick();
    // MgetappList()
    // window._czc.push(['_trackEvent', '点击', '该事件执行的内容']);
    //页面滚动到指定位置
    if (route.query.bottom) {
        window.scrollTo({
            top: 900,
            behavior: 'smooth'
        });
    } else {
        window.scrollTo(0, 0);
    }


    noreginList.value = reginList.value
    let aa = JSON.parse(JSON.stringify(reginList.value))
    aa.map(item => {
        item.platformList = []
    }
    )
    cityList.value = aa



});


let PlatformParms = ref({
    platformName: '',
})
//地级市
let reginList = ref(
    [
        {
            "id": 11,
            "parentId": 0,
            "title": "北京市",
            "key": "11",
            "value": "11",
            "hasChildren": true
        },
        {
            "id": 12,
            "parentId": 0,
            "title": "天津市",
            "key": "12",
            "value": "12",
            "hasChildren": true
        },
        {
            "id": 13,
            "parentId": 0,
            "title": "河北省",
            "key": "13",
            "value": "13",
            "hasChildren": true
        },
        {
            "id": 14,
            "parentId": 0,
            "title": "山西省",
            "key": "14",
            "value": "14",
            "hasChildren": true
        },
        {
            "id": 15,
            "parentId": 0,
            "title": "内蒙古",
            "key": "15",
            "value": "15",
            "hasChildren": true
        },
        {
            "id": 21,
            "parentId": 0,
            "title": "辽宁省",
            "key": "21",
            "value": "21",
            "hasChildren": true
        },
        {
            "id": 22,
            "parentId": 0,
            "title": "吉林省",
            "key": "22",
            "value": "22",
            "hasChildren": true
        },
        {
            "id": 23,
            "parentId": 0,
            "title": "黑龙江省",
            "key": "23",
            "value": "23",
            "hasChildren": true
        },
        {
            "id": 31,
            "parentId": 0,
            "title": "上海市",
            "key": "31",
            "value": "31",
            "hasChildren": true
        },
        {
            "id": 32,
            "parentId": 0,
            "title": "江苏省",
            "key": "32",
            "value": "32",
            "hasChildren": true
        },
        {
            "id": 33,
            "parentId": 0,
            "title": "浙江省",
            "key": "33",
            "value": "33",
            "hasChildren": true
        },
        {
            "id": 34,
            "parentId": 0,
            "title": "安徽省",
            "key": "34",
            "value": "34",
            "hasChildren": true
        },
        {
            "id": 35,
            "parentId": 0,
            "title": "福建省",
            "key": "35",
            "value": "35",
            "hasChildren": true
        },
        {
            "id": 36,
            "parentId": 0,
            "title": "江西省",
            "key": "36",
            "value": "36",
            "hasChildren": true
        },
        {
            "id": 37,
            "parentId": 0,
            "title": "山东省",
            "key": "37",
            "value": "37",
            "hasChildren": true
        },
        {
            "id": 41,
            "parentId": 0,
            "title": "河南省",
            "key": "41",
            "value": "41",
            "hasChildren": true
        },
        {
            "id": 42,
            "parentId": 0,
            "title": "湖北省",
            "key": "42",
            "value": "42",
            "hasChildren": true
        },
        {
            "id": 43,
            "parentId": 0,
            "title": "湖南省",
            "key": "43",
            "value": "43",
            "hasChildren": true
        },
        {
            "id": 44,
            "parentId": 0,
            "title": "广东省",
            "key": "44",
            "value": "44",
            "hasChildren": true
        },
        {
            "id": 46,
            "parentId": 0,
            "title": "海南省",
            "key": "46",
            "value": "46",
            "hasChildren": true
        },
        {
            "id": 45,
            "parentId": 0,
            "title": "广西",
            "key": "45",
            "value": "45",
            "hasChildren": true
        },

        {
            "id": 50,
            "parentId": 0,
            "title": "重庆市",
            "key": "50",
            "value": "50",
            "hasChildren": true
        },
        {
            "id": 51,
            "parentId": 0,
            "title": "四川省",
            "key": "51",
            "value": "51",
            "hasChildren": true
        },
        {
            "id": 52,
            "parentId": 0,
            "title": "贵州省",
            "key": "52",
            "value": "52",
            "hasChildren": true
        },
        {
            "id": 53,
            "parentId": 0,
            "title": "云南省",
            "key": "53",
            "value": "53",
            "hasChildren": true
        },
        {
            "id": 54,
            "parentId": 0,
            "title": "西藏",
            "key": "54",
            "value": "54",
            "hasChildren": true
        },
        {
            "id": 61,
            "parentId": 0,
            "title": "陕西省",
            "key": "61",
            "value": "61",
            "hasChildren": true
        },
        {
            "id": 62,
            "parentId": 0,
            "title": "甘肃省",
            "key": "62",
            "value": "62",
            "hasChildren": true
        },
        {
            "id": 63,
            "parentId": 0,
            "title": "青海省",
            "key": "63",
            "value": "63",
            "hasChildren": true
        },
        {
            "id": 64,
            "parentId": 0,
            "title": "宁夏",
            "key": "64",
            "value": "64",
            "hasChildren": true
        },
        {
            "id": 65,
            "parentId": 0,
            "title": "新疆",
            "key": "65",
            "value": "65",
            "hasChildren": true
        },


        {
            "id": 99,
            "parentId": 0,
            "title": "新疆兵团",
            "key": "99",
            "value": "99",
            "hasChildren": true
        },


    ])


//地级市
let noreginList = ref([])

//省级
let platformList = ref([
  {
    createTime: "2024-12-19 09:15:44",
    provinceName: "湖北省",
    provinceCode: "42",
    isNew: true,
    sort: 5,
    platformList: [],
    firstPlatform: {
      id: "1869552157550780418",
      platformCode: "",
      platformName: "湖北省电子招投标交易平台",
      platformUrl: "",
      platformOrgName: "湖北省公共资源交易中心",
      platformOrgCode: "12420000767423658J",
      platformContactName: "李炜",
      platformContactPhone: "13886032676",
      platformLogo: require("@/assets/img/image.png"),
      createUserName: "",
      updateUserName: "",
      createTime: "2025/3/30 18:30:56",
      platformRegionName: "湖北省",
    },
  },
]);
noreginList.value = reginList.value.filter(
  (item) => !platformList.value.some((item2) => item2.provinceCode == item.key)
);
let cityList = ref([{ platformList: [] }])

//跳转交易平台页面

const toplatform = () => {
    router.push({
        path: '/systemJoin',
        query: {
            bottom: true
        }
    })
}


//app列表
let applist = ref([])
// 跳转视频
const tovideo = () => {
    window.open('https://www.yunpan.com/surl_y9tqAvIvstR', '_blank')

}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(mytitle, {
        title: "对接实施具体步骤",
        style: {"margin-top":"64px"}
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_button, {
                class: "btn2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (Previewzn(7)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("预览")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                class: "btn1",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (downzn(7, '')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("下载")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_button, {
                class: "btn2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (Previewzn(7)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("预览")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                class: "btn1",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (downzn(7, '')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("下载")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _withDirectives(_createVNode(contactUs, null, null, 512), [
            [_vShow, _unref(showContactUs1)]
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_el_button, {
                class: "btn2",
                style: {"width":"256px"},
                onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_isRef(showContactUs1) //@ts-ignore
 ? showContactUs1.value = true : showContactUs1 = true)),
                onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_isRef(showContactUs1) //@ts-ignore
 ? showContactUs1.value = false : showContactUs1 = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("联系我们")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _hoisted_31
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createVNode(mytitle, {
          title: "互联电子评标工具目录",
          color: "white",
          style: {"margin-top":"64px"}
        }),
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_el_input, {
            modelValue: _unref(PlatformParms).platformName,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(PlatformParms).platformName) = $event)),
            placeholder: "请输入电子评标工具名称搜索",
            class: "paperview-input-text"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "searchbtn"
          }, {
            default: _withCtx(() => [
              _createTextVNode("搜索")
            ]),
            _: 1
          })
        ])
      ]),
      (!_ctx.isSearch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, "省级（" + _toDisplayString(_unref(platformList).length) + "）", 1),
            _createElementVNode("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(platformList), (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  onMouseover: ($event: any) => (item.isHovered = true),
                  onMouseout: ($event: any) => (item.isHovered = false),
                  onClick: ($event: any) => (_ctx.toPlatform(item.firstPlatform)),
                  style: {"cursor":"pointer"}
                }, [
                  _withDirectives(_createElementVNode("div", _hoisted_39, [
                    _createElementVNode("img", {
                      src: item.firstPlatform.platformLogo,
                      alt: "",
                      class: "appimgbox"
                    }, null, 8, _hoisted_40),
                    (item.isNew)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_41))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_vShow, !item.isHovered]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("img", {
                        src: item.firstPlatform.platformLogo,
                        alt: "",
                        class: "appimgn"
                      }, null, 8, _hoisted_44)
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, _toDisplayString(item.firstPlatform.platformContactName), 1),
                      _createElementVNode("div", _hoisted_47, _toDisplayString(item.firstPlatform.platformContactPhone), 1)
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _createElementVNode("span", _hoisted_50, _toDisplayString(item.firstPlatform.createTime), 1)
                    ])
                  ], 512), [
                    [_vShow, item.isHovered]
                  ])
                ], 40, _hoisted_38))
              }), 256)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(noreginList), (n) => {
                return (_openBlock(), _createElementBlock("div", {
                  style: {"cursor":"pointer"},
                  key: n
                }, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, _toDisplayString(n.title), 1)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_53, "地级市（" + _toDisplayString(_unref(total)) + "）", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cityList), (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, _toDisplayString(item.provinceName ? item.provinceName : item.title), 1),
                  _createElementVNode("div", _hoisted_56, " 共加入 " + _toDisplayString(item.platformList.length) + " 家", 1)
                ]),
                _createElementVNode("div", {
                  style: {"width":"1200px","margin-left":"-27px"},
                  onMouseenter: ($event: any) => (item.isHovered2 = true),
                  onMouseleave: ($event: any) => (item.isHovered2 = false)
                }, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      (item.platformList.length > 6)
                        ? (_openBlock(), _createBlock(_component_swiper, {
                            key: 0,
                            slidesPerView: 6,
                            spaceBetween: 0,
                            autoplay: {
                                    delay: 2500,
                                    disableOnInteraction: false
                                },
                            loop: true,
                            navigation: _ctx.navigation,
                            modules: _ctx.modules,
                            class: "mySwiper"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.platformList, (item2, index) => {
                                return (_openBlock(), _createBlock(_component_swiper_slide, {
                                  onMouseover: ($event: any) => (item2.isHovered = true),
                                  key: index,
                                  onMouseout: ($event: any) => (item2.isHovered = false),
                                  onClick: ($event: any) => (_ctx.toPlatform(item2)),
                                  style: {"cursor":"pointer"}
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("div", _hoisted_60, [
                                      _createElementVNode("img", {
                                        src: item2.platformLogo,
                                        alt: "",
                                        class: "appimgbox"
                                      }, null, 8, _hoisted_61),
                                      (item2.isNew)
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_62))
                                        : _createCommentVNode("", true),
                                      (_ctx.showcity(item2.platformRegionName))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(_ctx.showcity(item2.platformRegionName)), 1))
                                        : _createCommentVNode("", true)
                                    ], 512), [
                                      [_vShow, !item2.isHovered]
                                    ]),
                                    _withDirectives(_createElementVNode("div", _hoisted_64, [
                                      _createElementVNode("div", _hoisted_65, [
                                        _createElementVNode("img", {
                                          src: item2.platformLogo,
                                          alt: "",
                                          class: "appimgn"
                                        }, null, 8, _hoisted_66)
                                      ]),
                                      _createElementVNode("div", _hoisted_67, [
                                        _createElementVNode("div", _hoisted_68, _toDisplayString(item2.platformContactName), 1),
                                        _createElementVNode("div", _hoisted_69, _toDisplayString(item2.platformContactPhone), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_70, [
                                        _hoisted_71,
                                        _createElementVNode("span", _hoisted_72, _toDisplayString(item2.createTime), 1)
                                      ])
                                    ], 512), [
                                      [_vShow, item2.isHovered]
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["onMouseover", "onMouseout", "onClick"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["navigation", "modules"]))
                        : _createCommentVNode("", true),
                      (item.platformList.length <= 6)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.platformList, (item2, index2) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index2,
                              onMouseover: ($event: any) => (item2.isHovered = true),
                              onMouseout: ($event: any) => (item2.isHovered = false),
                              onClick: ($event: any) => (_ctx.toPlatform(item2)),
                              style: {"cursor":"pointer"}
                            }, [
                              _withDirectives(_createElementVNode("div", _hoisted_74, [
                                _createElementVNode("img", {
                                  src: item2.platformLogo,
                                  alt: "",
                                  class: "appimgbox"
                                }, null, 8, _hoisted_75),
                                (item2.isNew)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_76))
                                  : _createCommentVNode("", true),
                                (_ctx.showcity(item2.platformRegionName))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(_ctx.showcity(item2.platformRegionName)), 1))
                                  : _createCommentVNode("", true)
                              ], 512), [
                                [_vShow, !item2.isHovered]
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_78, [
                                _createElementVNode("div", _hoisted_79, [
                                  _createElementVNode("img", {
                                    src: item2.platformLogo,
                                    alt: "",
                                    class: "appimgn"
                                  }, null, 8, _hoisted_80)
                                ]),
                                _createElementVNode("div", _hoisted_81, [
                                  _createElementVNode("div", _hoisted_82, _toDisplayString(item2.platformContactName), 1),
                                  _createElementVNode("div", _hoisted_83, _toDisplayString(item2.platformContactPhone), 1)
                                ]),
                                _createElementVNode("div", _hoisted_84, [
                                  _hoisted_85,
                                  _createElementVNode("span", _hoisted_86, _toDisplayString(item2.createTime), 1)
                                ])
                              ], 512), [
                                [_vShow, item2.isHovered]
                              ])
                            ], 40, _hoisted_73))
                          }), 128))
                        : _createCommentVNode("", true),
                      (item.platformList.length < 6)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, _renderList(6, (item2, index3) => {
                            return _createElementVNode("div", {
                              key: index3,
                              style: {"cursor":"pointer"}
                            }, _hoisted_88)
                          }), 64))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createElementVNode("div", {
                      class: "swiper-button-prev",
                      onClick: _withModifiers(($event: any) => (_ctx.prevEl(item, index)), ["stop"])
                    }, [
                      _createElementVNode("div", {
                        class: "delStep",
                        style: {"position":"absolute","left":"-35px","top":"5px"},
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.prevCarousel && _ctx.prevCarousel(...args)))
                      }, _hoisted_91)
                    ], 8, _hoisted_89), [
                      [_vShow, item.platformList.length > 6 && item.isHovered2]
                    ]),
                    _withDirectives(_createElementVNode("div", {
                      class: "swiper-button-next swiper-button-next1",
                      onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextEl && _ctx.nextEl(...args)), ["stop"]))
                    }, [
                      _createElementVNode("div", {
                        class: "delStep",
                        style: {"position":"absolute","right":"-35px","top":"5px"},
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addstep && _ctx.addstep(...args)))
                      }, _hoisted_93)
                    ], 512), [
                      [_vShow, item.platformList.length > 6 && item.isHovered2]
                    ])
                  ])
                ], 40, _hoisted_57)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSearch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
            (_ctx.searchPlatform.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchPlatform, (item2, index2) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index2,
                      onMouseover: ($event: any) => (item2.isHovered = true),
                      onMouseout: ($event: any) => (item2.isHovered = false),
                      onClick: ($event: any) => (_ctx.toPlatform(item2)),
                      style: {"cursor":"pointer"}
                    }, [
                      _withDirectives(_createElementVNode("div", _hoisted_97, [
                        _createElementVNode("img", {
                          src: item2.platformLogo,
                          alt: "",
                          class: "appimgbox"
                        }, null, 8, _hoisted_98)
                      ], 512), [
                        [_vShow, !item2.isHovered]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_99, [
                        _createElementVNode("div", _hoisted_100, [
                          _createElementVNode("img", {
                            src: item2.platformLogo,
                            alt: "",
                            class: "appimgn"
                          }, null, 8, _hoisted_101)
                        ]),
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("div", _hoisted_103, _toDisplayString(item2.platformContactName), 1),
                          _createElementVNode("div", _hoisted_104, _toDisplayString(item2.platformContactPhone), 1)
                        ]),
                        _createElementVNode("div", _hoisted_105, [
                          _hoisted_106,
                          _createElementVNode("span", _hoisted_107, _toDisplayString(item2.createTime), 1)
                        ])
                      ], 512), [
                        [_vShow, item2.isHovered]
                      ])
                    ], 40, _hoisted_96))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.showmoreBtn)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "btnmore",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addPage(_unref(PlatformParms).platformName)))
                }, " 查看更多 "))
              : _createCommentVNode("", true),
            (_ctx.searchPlatform.length < 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_108, _hoisted_112))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_113,
    _createVNode(infoDailog, {
      showRegister: _unref(showRegister),
      registrationType: _unref(registrationType),
      onConfirm: confirm,
      onCanDownload: canDownload
    }, null, 8, ["showRegister", "registrationType"])
  ]))
}
}

})